import React from "react";
import "../assets/styles/bootstrap.css";
import cemeteryImage from "../assets/images/cemetery.jpg";
import { useTranslation } from "react-i18next";
import Carousel from "react-bootstrap/Carousel";

function Home() {
  const { t } = useTranslation();

  return (
    <div className="carousel-container">
      <Carousel data-bs-theme="dark">
        <Carousel.Item>
          <img
            src={cemeteryImage}
            alt="cemetery"
            className="d-block w-100 cemetery-image"
            width="500"
            height="600"
          />
          <Carousel.Caption>
            <h3>{t("welcome")}</h3>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
    </div>
  );
}

export default Home;
